import { MenuObject } from '../interfaces/menu-object.interface'
import { NextPageRoute } from '../interfaces/next-page-route.interface'

export class NextPageOptionsModel {
  public sitename = 'change the sitename property on header'
  public menuStructure: Array<MenuObject>
  public eventResizeThreshold: number
  public swipeDistanceThreshold: number
  public mobileThreshold: number
  public tabletThreshold: number
  public slideRotationInterval: number
  public alertDisableDuration: number
  public navigationItems: any[] = []
  public navigationRoutes: NextPageRoute[] = []

  constructor() {
    this.eventResizeThreshold = 100
    this.swipeDistanceThreshold = 0.3
    this.mobileThreshold = 768
    this.tabletThreshold = 1200
    this.slideRotationInterval = 6000
    this.alertDisableDuration = 86400000
  }
}
